var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ESLBaseElement } from '@exadel/esl/modules/esl-base-element/core';
import { ESLTraversingQuery } from '@exadel/esl/modules/esl-traversing-query/core';
import { attr, memoize } from '@exadel/esl/modules/esl-utils/decorators';
import { UIPRoot } from './root';
/**
 * Base class for UI Playground plugins
 * Implements basic relation and styles
 */
export class UIPPlugin extends ESLBaseElement {
    /** Closest playground {@link UIPRoot} element */
    get $root() {
        return ESLTraversingQuery.first(this.root, this);
    }
    /** Returns {@link UIPStateModel} from $root instance */
    get model() {
        return this.$root ? this.$root.model : null;
    }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('uip-plugin');
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        memoize.clear(this, '$root');
    }
    attributeChangedCallback(attrName, oldVal, newVal) {
        if (attrName === 'label')
            this.setAttribute('aria-label', newVal);
        if (attrName === 'root')
            memoize.clear(this, '$root');
    }
}
UIPPlugin.observedAttributes = ['root', 'label'];
__decorate([
    attr()
], UIPPlugin.prototype, "label", void 0);
__decorate([
    attr({ defaultValue: `::parent(${UIPRoot.is})` })
], UIPPlugin.prototype, "root", void 0);
__decorate([
    memoize()
], UIPPlugin.prototype, "$root", null);
